import React, {Component} from 'react';
import {Select, Input, Form} from "antd";

const { TextArea } = Input;

class TextareaInput extends Component {

    static defaultProps = {
        width: 642,
        maxLength:1000,
    };

    render() {
        return (
            // <div style={{display:"flex"}}>
            //     <div>
            //         <span style={{color:"#E03030"}}>*</span>
            //         <span>{this.props.label}</span>
            //     </div>
            //     <div>
            //
            //     </div>
            // </div>
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <Input.TextArea placeholder={this.props.placeholder?this.props.placeholder:"请输入"+this.props.label.substr(0,2)+"内容"} value={this.props.itemValue} maxLength={this.props.maxLength} rows={4} style={{width: this.props.width, background: "rgba(0, 80, 179, 0.04)",border: "1px solid rgba(0, 80, 179, 0.08)",resize:"none" }}
                onChange={(e)=>{
                    this.props.callBack&& this.props.callBack(e.target.value)
                }}
                />
            </Form.Item>
        );
    }
}

export default TextareaInput;
